import React from 'react';
import { ClassNames } from 'packages/theming';
import Masonry from 'react-masonry-css';
import { Category } from 'types';
import { Box, constants, Text } from '@match/react-component-library';
import { Topics } from './Topics';

const { SEMANTIC_COLOR_NAME, SPACE, TYPOGRAPHY } = constants;

interface CategoryViewProps {
  activeCategoryId?: number | string;
  currentSubCategories: Category[];
}

const myMasonryGrid = {
  display: 'flex',
  listStyle: 'none',
  paddingTop: 'none',
};

const SubCategoryView = ({ currentSubCategories }: CategoryViewProps) => {
  const subCategories = currentSubCategories.map((subCategory, index) => {
    const subCategoryId = subCategory.id;
    const topics = subCategory.topics;

    return (
      <Box key={subCategoryId} marginRight={SPACE.MEDIUM}>
        <Box
          borderBottom={currentSubCategories.length > 1 ? '2px solid' : undefined}
          borderColor={SEMANTIC_COLOR_NAME.GRAY_5}
          paddingBottom={SPACE.XXLARGE}
          marginBottom={SPACE.MEDIUM}
        >
          <Text typography={TYPOGRAPHY.HEADING5} bold>
            {subCategory.name}
          </Text>
          <Topics key={index} topics={topics} />
        </Box>
      </Box>
    );
  });

  return (
    <ClassNames>
      {({ css }) => (
        <Masonry
          breakpointCols={currentSubCategories.length > 1 ? 2 : 1}
          className={css(myMasonryGrid)}
          columnClassName="my-masonry-grid_column"
        >
          {subCategories}
        </Masonry>
      )}
    </ClassNames>
  );
};

export default SubCategoryView;
